import logger from "redux-logger";

export const FETCH_AUDITTRACEDETAILS_INIT_ACTION =
  "FETCH_AUDITTRACEDETAILS_INIT_ACTION";
export const FETCH_AUDITTRACEDETAILS_SUCCESS_ACTION =
  FETCH_AUDITTRACEDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_AUDITTRACEDETAILS_FAIL_ACTION =
  FETCH_AUDITTRACEDETAILS_INIT_ACTION + "_ERROR";

export function auditTraceList() {
  return {
    type: FETCH_AUDITTRACEDETAILS_INIT_ACTION
  };
}
export function AuditTraceSelectedPage(value) {
  return {
    type: FETCH_AUDITTRACEDETAILS_INIT_ACTION,
    value: value
  };
}
